module.exports = __webpack_public_path__ + "static/media/close_green.689dbe85.svg";